// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  border-collapse: collapse;
  border-spacing: 0;
}

.ContractReportTable_wrapper__jm6Q5 {
  width: 100%;
  position: relative;
  overflow-x: auto;
  margin-bottom: 100px;
}
.ContractReportTable_wrapper__Kontur__VkqhA {
  margin-bottom: 40px;
}
.ContractReportTable_wrapper__Kontur__VkqhA {
  margin-bottom: 40px;
}
.ContractReportTable_wrapper__ofrTable__pY7w9 {
  height: 60vh;
  margin-bottom: 0px;
}
.ContractReportTable_wrapper__jm6Q5::-webkit-scrollbar {
  height: 0.5em;
  width: 0.5em;
}
.ContractReportTable_wrapper__jm6Q5::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 4px #5dc689;
}
.ContractReportTable_wrapper__jm6Q5::-webkit-scrollbar-thumb {
  background-color: #1dc255;
  outline: 1px solid #5dc689;
  width: 100px;
  border-radius: 5px;
}

.ContractReportTable_balanceTable__header__1PHBV {
  position: sticky;
  top: -1px;
  background-color: #f1f9f7;
  z-index: 4;
  overflow: visible;
}
.ContractReportTable_balanceTable__header__1PHBV tr th {
  border: 1px solid #d7d7d8;
}
.ContractReportTable_balanceTable__header__1PHBV tr th:nth-child(1) {
  position: sticky;
  left: 0;
  background-color: #f1f9f7;
  z-index: 2;
  overflow: visible;
}
.ContractReportTable_balanceTable__header__1PHBV tr th:nth-child(1)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  height: 100%;
  border-right: 1px solid #d7d7d8;
}
.ContractReportTable_balanceTable__header__1PHBV tr th:nth-child(2) {
  position: sticky;
  left: 295px;
  background-color: #f1f9f7;
  z-index: 2;
  overflow: visible;
}
.ContractReportTable_balanceTable__header__1PHBV tr th:nth-child(2)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  height: 100%;
  border-right: 1px solid #d7d7d8;
}
.ContractReportTable_balanceTable__header__name__lF94e {
  width: 270px;
  min-width: 270px;
  font-family: Raleway;
  color: #000000;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  padding: 6px 12px;
  text-transform: none;
  font-feature-settings: "lnum";
  text-align: start;
}
.ContractReportTable_balanceTable__header__code__zFEl3 {
  width: 100px;
  min-width: 100px;
  font-family: Raleway;
  color: #000000;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  padding: 6px 0px;
  text-align: center;
  text-transform: none;
  font-feature-settings: "lnum";
}
.ContractReportTable_balanceTable__header__year__ZeSx2 {
  width: 82px;
  min-width: 82px;
  font-family: Raleway;
  color: #000000;
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  padding: 6px 10px 6px 10px;
  text-transform: none;
  font-feature-settings: "lnum";
  text-align: end;
}
.ContractReportTable_balanceTable__header__year__container__y\\+DzD {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
}
.ContractReportTable_balanceTable__name__JDY8L {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  padding: 6px 44px;
  text-align: start;
}
.ContractReportTable_balanceTable__code__4txmM {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #000000;
  padding: 6px 16px;
  text-align: center;
  text-transform: none;
  font-feature-settings: "lnum";
}
.ContractReportTable_balanceTable__nanRow__LZ0aE {
  visibility: hidden;
}
.ContractReportTable_balanceTable__year__HZCLR {
  width: 82px;
  padding: 6px 6px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  text-align: end;
}
.ContractReportTable_balanceTable__year__value__znu8Z {
  width: 100%;
  font-family: Raleway;
  font-weight: 400;
  font-size: 13px;
  color: #000000;
  text-align: end;
  line-height: 16px;
  border: none;
  outline: none;
  background-color: #ffffff;
  text-transform: none;
  font-feature-settings: "lnum";
}
.ContractReportTable_balanceTable__year__valueDisabled__9KBb9 {
  width: 100%;
  font-family: Raleway;
  font-weight: 400;
  font-size: 13px;
  color: #000000;
  text-align: end;
  border: none;
  outline: none;
  background-color: #ffffff;
  text-transform: none;
  font-feature-settings: "lnum";
}
.ContractReportTable_balanceTable__container__nssc9 td {
  border: 1px solid #d7d7d8;
}
.ContractReportTable_balanceTable__container__nssc9 td:nth-child(1) {
  position: sticky;
  left: 0;
  background-color: #ffffff;
  z-index: 2;
  overflow: visible;
}
.ContractReportTable_balanceTable__container__nssc9 td:nth-child(1)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  height: 100%;
  border-right: 1px solid #d7d7d8;
}
.ContractReportTable_balanceTable__container__nssc9 td:nth-child(2) {
  position: sticky;
  left: 295px;
  background-color: #ffffff;
  z-index: 2;
  overflow: visible;
}
.ContractReportTable_balanceTable__container__nssc9 td:nth-child(2)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  height: 100%;
  border-right: 1px solid #d7d7d8;
}
.ContractReportTable_balanceTable__specialRow__Vxezx td {
  font-weight: 800;
}
.ContractReportTable_balanceTable__specialRow__Vxezx .ContractReportTable_balanceTable__year__value__znu8Z {
  font-weight: 800;
}
.ContractReportTable_balanceTable__specialRow__Vxezx .ContractReportTable_balanceTable__name__JDY8L {
  padding: 6px 12px;
}
.ContractReportTable_balanceTable__specialRowCode__m1plm {
  border-left: 1px solid #d7d7d8;
  border-right: 1px solid #d7d7d8;
}

.ContractReportTable_buttonPeriod__zdJQM {
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  fill: #000000;
}
.ContractReportTable_buttonPeriod__zdJQM:hover {
  fill: #616161;
  transition: all 0.2s ease-in-out;
}

.ContractReportTable_button__ub39b {
  position: absolute;
  top: 0px;
  right: 0;
}

.ContractReportTable_modal__4gwJ- {
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 100;
  background-color: #e6e6e6;
  border-radius: 5px;
  padding: 15px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ContractReportTable_modal__4gwJ- button {
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.ContractReportTable_success__Fd9M2 {
  position: fixed;
  bottom: 90px;
  width: 400px;
  right: 50px;
  z-index: 1000;
}

.ContractReportTable_calculationInput__kaD4t {
  width: 100%;
  background-color: transparent;
  outline: none;
  border: none;
  text-align: end;
  font-family: Raleway;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  text-transform: none;
  font-feature-settings: "lnum";
}

.ContractReportTable_tableErrorContainer__vYP4u::-webkit-scrollbar {
  height: 0.5em;
  width: 0.5em;
}
.ContractReportTable_tableErrorContainer__vYP4u::-webkit-scrollbar-thumb {
  background-color: #ff0000;
  outline: 1px solid #5dc689;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Contagents/ContactTabs/ContractReportTable.module.scss","webpack://./src/constants/_colors.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,iBAAA;AADJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAAJ;AACI;EACI,mBAAA;AACR;AAEI;EACI,mBAAA;AAAR;AAGI;EACI,YAAA;EACA,kBAAA;AADR;AAII;EACI,aAAA;EACA,YAAA;AAFR;AAKI;EACI,yCAAA;AAHR;AAMI;EACI,yBCrBM;EDsBN,0BAAA;EACA,YAAA;EACA,kBAAA;AAJR;;AAQI;EACI,gBAAA;EACA,SAAA;EACA,yBCnCa;EDoCb,UAAA;EACA,iBAAA;AALR;AAOY;EACI,yBAAA;AALhB;AAOY;EACI,gBAAA;EACA,OAAA;EACA,yBC7CK;ED8CL,UAAA;EACA,iBAAA;AALhB;AAQY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AANhB;AAQY;EACI,gBAAA;EACA,WAAA;EACA,yBC7DK;ED8DL,UAAA;EACA,iBAAA;AANhB;AASY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAPhB;AAUQ;EACI,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,cCxFJ;EDyFI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,iBAAA;AARZ;AAUQ;EACI,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,cCtGJ;EDuGI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;AARZ;AAUQ;EACI,WAAA;EACA,eAAA;EACA,oBAAA;EACA,cCpHJ;EDqHI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,oBAAA;EACA,6BAAA;EACA,eAAA;AARZ;AASY;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAPhB;AAWI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cC1IA;ED2IA,iBAAA;EACA,iBAAA;AATR;AAWI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cCnJA;EDoJA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;AATR;AAWI;EACI,kBAAA;AATR;AAWI;EACI,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cCnKA;EDoKA,eAAA;AATR;AAUQ;EACI,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,cC1KJ;ED2KI,eAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,yBC9KJ;ED+KI,oBAAA;EACA,6BAAA;AARZ;AAUQ;EACI,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,cCxLJ;EDyLI,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBC3LJ;ED4LI,oBAAA;EACA,6BAAA;AARZ;AAYQ;EACI,yBAAA;AAVZ;AAYQ;EACI,gBAAA;EACA,OAAA;EACA,yBCvMJ;EDwMI,UAAA;EACA,iBAAA;AAVZ;AAaQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAXZ;AAaQ;EACI,gBAAA;EACA,WAAA;EACA,yBCvNJ;EDwNI,UAAA;EACA,iBAAA;AAXZ;AAcQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAZZ;AAgBQ;EACI,gBAAA;AAdZ;AAgBQ;EACI,gBAAA;AAdZ;AAgBQ;EACI,iBAAA;AAdZ;AAiBI;EACI,8BAAA;EACA,+BAAA;AAfR;;AAmBA;EACI,6BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aC9PI;AD8OR;AAiBI;EACI,aCrPI;EDsPJ,gCAAA;AAfR;;AAkBA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;AAfJ;;AAkBA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,yBC5QY;ED6QZ,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAfJ;AAgBI;EACI,6BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAdR;;AAkBA;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAfJ;;AAkBA;EACI,WAAA;EACA,6BAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,cC/SI;EDgTJ,oBAAA;EACA,6BAAA;AAfJ;;AAkBI;EACI,aAAA;EACA,YAAA;AAfR;AAiBI;EACI,yBCnTF;EDoTE,0BAAA;EACA,kBAAA;AAfR","sourcesContent":["@import \"@/constants/colors\";\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n.wrapper {\n    width: 100%;\n    position: relative;\n    overflow-x: auto;\n    margin-bottom: 100px;\n    &__Kontur {\n        margin-bottom: 40px;\n    }\n\n    &__Kontur {\n        margin-bottom: 40px;\n    }\n\n    &__ofrTable {\n        height: 60vh;\n        margin-bottom: 0px;\n    }\n\n    &::-webkit-scrollbar {\n        height: 0.5em;\n        width: 0.5em;\n    }\n\n    &::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 4px $emerald;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: $light_green;\n        outline: 1px solid $emerald;\n        width: 100px;\n        border-radius: 5px;\n    }\n}\n.balanceTable {\n    &__header {\n        position: sticky;\n        top: -1px;\n        background-color: $periwinkle_crayola;\n        z-index: 4;\n        overflow: visible;\n        tr {\n            th {\n                border: 1px solid $pale_blue;\n            }\n            th:nth-child(1) {\n                position: sticky;\n                left: 0;\n                background-color: $periwinkle_crayola;\n                z-index: 2;\n                overflow: visible;\n            }\n\n            th:nth-child(1)::after {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                right: -1px;\n                height: 100%;\n                border-right: 1px solid $pale_blue;\n            }\n            th:nth-child(2) {\n                position: sticky;\n                left: 295px;\n                background-color: $periwinkle_crayola;\n                z-index: 2;\n                overflow: visible;\n            }\n\n            th:nth-child(2)::after {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                right: -1px;\n                height: 100%;\n                border-right: 1px solid $pale_blue;\n            }\n        }\n        &__name {\n            width: 270px;\n            min-width: 270px;\n            font-family: Raleway;\n            color: $black;\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 16px;\n            padding: 6px 12px;\n            text-transform: none;\n            font-feature-settings: \"lnum\";\n            text-align: start;\n        }\n        &__code {\n            width: 100px;\n            min-width: 100px;\n            font-family: Raleway;\n            color: $black;\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 16px;\n            padding: 6px 0px;\n            text-align: center;\n            text-transform: none;\n            font-feature-settings: \"lnum\";\n        }\n        &__year {\n            width: 82px;\n            min-width: 82px;\n            font-family: Raleway;\n            color: $black;\n            font-style: normal;\n            font-weight: 700;\n            font-size: 13px;\n            line-height: 16px;\n            padding: 6px 10px 6px 10px;\n            text-transform: none;\n            font-feature-settings: \"lnum\";\n            text-align: end;\n            &__container {\n                display: flex;\n                align-items: center;\n                justify-content: flex-end;\n                gap: 7px;\n            }\n        }\n    }\n    &__name {\n        font-family: Raleway;\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: $black;\n        padding: 6px 44px;\n        text-align: start;\n    }\n    &__code {\n        font-family: Raleway;\n        font-style: normal;\n        font-weight: 400;\n        font-size: 13px;\n        color: $black;\n        padding: 6px 16px;\n        text-align: center;\n        text-transform: none;\n        font-feature-settings: \"lnum\";\n    }\n    &__nanRow {\n        visibility: hidden;\n    }\n    &__year {\n        width: 82px;\n        padding: 6px 6px;\n        font-family: Raleway;\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: $black;\n        text-align: end;\n        &__value {\n            width: 100%;\n            font-family: Raleway;\n            font-weight: 400;\n            font-size: 13px;\n            color: $black;\n            text-align: end;\n            line-height: 16px;\n            border: none;\n            outline: none;\n            background-color: $white;\n            text-transform: none;\n            font-feature-settings: \"lnum\";\n        }\n        &__valueDisabled {\n            width: 100%;\n            font-family: Raleway;\n            font-weight: 400;\n            font-size: 13px;\n            color: $black;\n            text-align: end;\n            border: none;\n            outline: none;\n            background-color: $white;\n            text-transform: none;\n            font-feature-settings: \"lnum\";\n        }\n    }\n    &__container {\n        td {\n            border: 1px solid $pale_blue;\n        }\n        td:nth-child(1) {\n            position: sticky;\n            left: 0;\n            background-color: $white;\n            z-index: 2;\n            overflow: visible;\n        }\n\n        td:nth-child(1)::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            right: -1px;\n            height: 100%;\n            border-right: 1px solid $pale_blue;\n        }\n        td:nth-child(2) {\n            position: sticky;\n            left: 295px;\n            background-color: $white;\n            z-index: 2;\n            overflow: visible;\n        }\n\n        td:nth-child(2)::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            right: -1px;\n            height: 100%;\n            border-right: 1px solid $pale_blue;\n        }\n    }\n    &__specialRow {\n        td {\n            font-weight: 800;\n        }\n        .balanceTable__year__value {\n            font-weight: 800;\n        }\n        .balanceTable__name {\n            padding: 6px 12px;\n        }\n    }\n    &__specialRowCode {\n        border-left: 1px solid $pale_blue;\n        border-right: 1px solid $pale_blue;\n    }\n}\n\n.buttonPeriod {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    fill: $black;\n    &:hover {\n        fill: $dull_grey;\n        transition: all 0.2s ease-in-out;\n    }\n}\n.button {\n    position: absolute;\n    top: 0px;\n    right: 0;\n}\n\n.modal {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    z-index: 100;\n    background-color: $slightly_grey;\n    border-radius: 5px;\n    padding: 15px;\n    width: 250px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    button {\n        background-color: transparent;\n        border: none;\n        outline: none;\n        cursor: pointer;\n    }\n}\n\n.success {\n    position: fixed;\n    bottom: 90px;\n    width: 400px;\n    right: 50px;\n    z-index: 1000;\n}\n\n.calculationInput {\n    width: 100%;\n    background-color: transparent;\n    outline: none;\n    border: none;\n    text-align: end;\n    font-family: Raleway;\n    font-weight: 500;\n    font-size: 14px;\n    color: $black;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n}\n.tableErrorContainer {\n    &::-webkit-scrollbar {\n        height: 0.5em;\n        width: 0.5em;\n    }\n    &::-webkit-scrollbar-thumb {\n        background-color: $red;\n        outline: 1px solid $emerald;\n        border-radius: 5px;\n    }\n}\n","$black: #000000;\n$white: #ffffff;\n$grey: #6e6e6e;\n$slightly_grey: #e6e6e6;\n$light-gray: #def3db;\n$gray_smoke: #bdbdbd;\n$red: #ff0000;\n$heavenly: #61dafb;\n$granite_grey: #282c34;\n$periwinkle_crayola: #f1f9f7;\n$pale_blue: #d7d7d8;\n$dull_grey: #616161;\n$emerald: #5dc689;\n$light_green: #1dc255;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ContractReportTable_wrapper__jm6Q5`,
	"wrapper__Kontur": `ContractReportTable_wrapper__Kontur__VkqhA`,
	"wrapper__ofrTable": `ContractReportTable_wrapper__ofrTable__pY7w9`,
	"balanceTable__header": `ContractReportTable_balanceTable__header__1PHBV`,
	"balanceTable__header__name": `ContractReportTable_balanceTable__header__name__lF94e`,
	"balanceTable__header__code": `ContractReportTable_balanceTable__header__code__zFEl3`,
	"balanceTable__header__year": `ContractReportTable_balanceTable__header__year__ZeSx2`,
	"balanceTable__header__year__container": `ContractReportTable_balanceTable__header__year__container__y+DzD`,
	"balanceTable__name": `ContractReportTable_balanceTable__name__JDY8L`,
	"balanceTable__code": `ContractReportTable_balanceTable__code__4txmM`,
	"balanceTable__nanRow": `ContractReportTable_balanceTable__nanRow__LZ0aE`,
	"balanceTable__year": `ContractReportTable_balanceTable__year__HZCLR`,
	"balanceTable__year__value": `ContractReportTable_balanceTable__year__value__znu8Z`,
	"balanceTable__year__valueDisabled": `ContractReportTable_balanceTable__year__valueDisabled__9KBb9`,
	"balanceTable__container": `ContractReportTable_balanceTable__container__nssc9`,
	"balanceTable__specialRow": `ContractReportTable_balanceTable__specialRow__Vxezx`,
	"balanceTable__specialRowCode": `ContractReportTable_balanceTable__specialRowCode__m1plm`,
	"buttonPeriod": `ContractReportTable_buttonPeriod__zdJQM`,
	"button": `ContractReportTable_button__ub39b`,
	"modal": `ContractReportTable_modal__4gwJ-`,
	"success": `ContractReportTable_success__Fd9M2`,
	"calculationInput": `ContractReportTable_calculationInput__kaD4t`,
	"tableErrorContainer": `ContractReportTable_tableErrorContainer__vYP4u`
};
export default ___CSS_LOADER_EXPORT___;
